export class PageAction {
    public Id: string = '';
    public ReportItemName: string = '';
    public Type: string = '';
    public Value: any = {};
}
